<template>
  <div @scroll="updateActiveCategory" class="menu">
    <transition name="fade">
      <DateAndTimeModal
        v-if="dateAndTimeModalIsOpen"
        @closeModal="toggleDateAndTimeModal"
        @openDiscountModal="openDiscountModal"
        @addDeepLinkItemToCart="addDeepLinkItemToCart"
      />
    </transition>
    <transition name="fade">
      <PendingDiscountModal
        v-if="pendingDiscountModalIsOpen"
        @closeModal="togglePendingDiscountModal"
        :discountData="pendingDiscountData"
      />
    </transition>
    <transition name="slide">
      <CartModal
        v-if="cartIsOpen"
        @closeModal="toggleCartViewModal"
        @checkoutClicked="toggleCartViewModal"
        @openUpsellItem="openUpsellItem"
        @openWithAddons="openEditWithAddons"
      />
    </transition>
    <transition name="slide">
      <WithAddons
        v-if="withAddonsModalIsOpen"
        @closeModal="toggleWithAddonsModal"
        :itemData="itemData"
        :normalizedAddons="normalizedAddons"
        :mode="itemModalMode"
        :editItemData="editItemData"
      />
    </transition>
    <transition name="fade">
      <FilterModalAllergen
        v-if="filterModalIsOpen"
        @closeModal="toggleFilterModal"
        @applyFilter="handleFilter"
        :selectedAllergen="this.selectedAllergens"
        :selectedItemClass="this.selectedItemClasses"
        :preferencesAllergen="this.preferencesAllergens"
        :preferencesItemClass="this.preferencesItemClasses"
        @add-to-selected-allergen="selectedAllergens.push($event)"
        @remove-from-selected-allergen="selectedAllergens.splice($event, 1)"
        @add-to-selected-item-class="selectedItemClasses.push($event)"
        @remove-from-selected-item-class="selectedItemClasses.splice($event, 1)"
        @clear-selected-filters="clearFilter()"
      />
    </transition>
    <HeroView />
    <LoaderView v-if="!menus || showLoader" :showLoader="showLoader" />
    <div v-if="checkIfMenuVisible" class="menuWrapper">
      <div class="categories">
        <div
          v-if="
            getAvailableMenus &&
            getAvailableMenus.length > 1 &&
            !this.branding?.display_options?.collapse_menu_categories
          "
          class="topMenusWrapper"
        >
          <swiper
            :navigation="true"
            :slidesPerView="'auto'"
            :slidesPerGroup="1"
            :spaceBetween="15"
            :modules="modules"
            @swiper="onSwiper"
            class="swiperGradientRight"
          >
            <swiper-slide
              :class="{ selectedMenu: selectedMenuIndex == index }"
              @click="changeMenu(index)"
              v-for="(menu, index) in getAvailableMenus"
              :key="menu.menu_id"
            >
              <p class="topCategory">{{ menu.name }}</p>
            </swiper-slide>
            <div v-if="!swiperSlideData.isBeginning" class="gradientLeft"></div>
            <div v-if="!swiperSlideData.isEnd" class="gradientRight"></div>
          </swiper>
        </div>
        <div
          :style="{
            display: (branding && branding.category_placement == 'top') || innerWidth <= 768 ? 'flex' : 'none',
          }"
          class="topCategoriesWrapper"
        >
          <swiper
            :navigation="true"
            :slidesPerView="'auto'"
            :slidesPerGroup="1"
            :spaceBetween="15"
            :modules="modules"
            @slideChange="getActiveSlide($event)"
            @swiper="onSwiper"
            class="mySwiper"
          >
            <swiper-slide
              v-for="(topCategory, index) in getTopCategories"
              :key="topCategory.category_id"
              @click="scrollToCategory(topCategory.category_id, index)"
              :class="{ active: activeCategoryIndex == index }"
            >
              <p class="topCategory">{{ topCategory.name }}</p>
            </swiper-slide>
            <div v-if="!swiperSlideData.isBeginning" class="gradientLeft"></div>
            <div v-if="!swiperSlideData.isEnd" class="gradientRight"></div>
          </swiper>
          <div class="inputWrapper">
            <svg class="searchIcon" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path
                id="Search"
                d="M16.912,17.814l-4.279-4.279a7.686,7.686,0,1,1,.9-.9l4.279,4.279a.637.637,0,0,1-.9.9ZM1.274,7.677a6.4,6.4,0,1,0,6.4-6.4A6.409,6.409,0,0,0,1.274,7.677Z"
                transform="translate(0.5 0.5)"
                fill="#292828"
                stroke="rgba(0,0,0,0)"
                stroke-miterlimit="10"
                stroke-width="1"
              />
            </svg>
            <input @keyup="searchItems()" v-model="search" class="searchInput" type="text" placeholder="Search Items" />
            <img v-if="search.length >= 3" class="clearSearch" @click="clearSearch" src="@/assets/icons/close.svg" />
          </div>
        </div>
        <div
          v-if="selectedStore && selectedStore.promo_text && selectedStore.promo_text != '' && !searchedItems"
          class="promoPart"
        >
          <p
            v-html="getPurifiedBody"
            :style="{
              backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF',
              border: branding.dark_mode_enabled ? '1px solid var(--border-color)' : 'none',
            }"
          ></p>
        </div>
        <div
          class="menuGrid"
          :style="{
            'grid-template-columns': branding && branding.category_placement == 'top' ? '1fr' : '200px 1fr',
          }"
        >
          <div
            :style="{
              display: branding && branding.category_placement == 'side' ? 'block' : 'none',
            }"
            class="leftCategoriesWrapper"
          >
            <div class="leftCategories">
              <div class="inputWrapper">
                <svg class="searchIcon" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                  <path
                    id="Search"
                    d="M16.912,17.814l-4.279-4.279a7.686,7.686,0,1,1,.9-.9l4.279,4.279a.637.637,0,0,1-.9.9ZM1.274,7.677a6.4,6.4,0,1,0,6.4-6.4A6.409,6.409,0,0,0,1.274,7.677Z"
                    transform="translate(0.5 0.5)"
                    fill="#292828"
                    stroke="rgba(0,0,0,0)"
                    stroke-miterlimit="10"
                    stroke-width="1"
                  />
                </svg>
                <input
                  @keyup="searchItems"
                  v-model="search"
                  class="searchInput"
                  type="text"
                  placeholder="Search Items"
                />
                <img
                  v-if="search.length >= 3"
                  class="clearSearch"
                  @click="clearSearch"
                  src="@/assets/icons/close.svg"
                  role="button"
                  aria-label="Clear search"
                  tabindex="0"
                  @keydown.enter="clearSearch"
                />
              </div>
              <div
                v-for="category in getAvailableMenus[selectedMenuIndex].categories"
                :key="category.category_id"
                class="leftCategory"
                @click="scrollToCategory(category.category_id, index)"
                @keyup.enter="scrollToCategory(category.category_id, index)"
                tabindex="0"
              >
                <div class="categoryLine" :class="{ leftSelected: activeCategoryId == category.category_id }">
                  <img
                    v-if="branding.display_options?.category_image?.show"
                    :style="{
                      'border-radius': branding.display_options?.category_image.type == 'image' ? '50%' : '0',
                      'object-fit': branding.display_options?.category_image.type == 'image' ? 'cover' : 'contain',
                    }"
                    :src="category.image_urls.thumbnail"
                    :alt="category.name"
                  />
                  <p>{{ category.name }}</p>
                </div>
                <div
                  class="leftSubCategory"
                  v-for="subCategory in category.categories"
                  :key="subCategory.category_id"
                  @click.stop="scrollToCategory(subCategory.category_id)"
                  @keyup.enter.stop="scrollToCategory(subCategory.category_id)"
                  :class="{ leftSelected: activeSubCategoryId == subCategory.category_id }"
                  tabindex="0"
                >
                  <div class="categoryLine">
                    <img
                      v-if="branding.display_options?.category_image?.show"
                      :style="{
                        'border-radius': branding.display_options?.category_image.type == 'image' ? '50%' : '0',
                        'object-fit': branding.display_options?.category_image.type == 'image' ? 'cover' : 'contain',
                      }"
                      :src="subCategory.image_urls.thumbnail"
                      :alt="subCategory.name"
                    />
                    <p>{{ subCategory.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="categoryList">
            <div v-if="searchedItems">
              <div class="searchTopPart">
                <h4 class="searchResultText" v-if="searchedItems && searchedItems.length != 0">
                  {{ searchedItems.length }} results for '{{ search }}'
                </h4>
                <h4 class="searchResultText" v-if="searchedItems && searchedItems.length == 0">
                  No result for '{{ search }}'
                </h4>
                <a class="clear" @click="clearSearch" role="button" href="javascript:void(0);">
                  <p>CLEAR SEARCH RESULTS</p>
                </a>
              </div>
              <div class="searchResults" aria-live="polite" aria-atomic="true">
                <div
                  @click="getItemData(item, item.category, 'add')"
                  class="item"
                  :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                  v-for="item in searchedItems"
                  :key="item.item_id"
                >
                  <ItemCell
                    :item="item"
                    :category="item.category"
                    @getItemData="getItemData"
                    @changeQty="changeQty"
                    :orderData="orderData"
                    :qtyLoading="qtyLoading"
                    :selectedItemId="selectedItemId"
                    :quickAddLoadingItemId="quickAddLoadingItemId"
                    :fillScreenAnimation="fillScreenAnimation"
                    :fillScreenItemId="fillScreenItemId"
                    :flyToCardItemId="flyToCardItemId"
                  />
                </div>
              </div>
            </div>
            <div v-if="!searchedItems">
              <div v-if="selectedStore && getFilteredSuggestions?.length != 0" class="suggestions">
                <div v-if="branding.suggestions" class="suggestionGroupHeader">
                  <h2>{{ branding.suggestions.main_header }}</h2>
                  <div ref="filterDropdown" v-if="suggestions.length > 1" class="inputWrapper">
                    <svg
                      class="arrow"
                      width="12"
                      height="9"
                      viewBox="0 0 12 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.53558 7.93101L0.221517 2.61692C-0.0347764 2.36063 -0.0347764 1.94511 0.221517 1.68885L0.841317 1.06904C1.09717 0.813189 1.51184 0.812697 1.7683 1.06795L5.99963 5.27946L10.2309 1.06795C10.4874 0.812697 10.9021 0.813189 11.1579 1.06904L11.7777 1.68885C12.034 1.94514 12.034 2.36065 11.7777 2.61692L6.46368 7.93101C6.20739 8.18728 5.79188 8.18728 5.53558 7.93101Z"
                        fill="#171717"
                      />
                    </svg>
                    <div @click="toggleFilterDropdown" class="customSelect">
                      <p>{{ selectedSuggestionFilter }}</p>
                    </div>
                    <div
                      v-if="filterDropdownIsOpen"
                      class="dropdown"
                      :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                    >
                      <div
                        @click="selectFilter('See All')"
                        :class="{
                          selected: 'See All' == selectedSuggestionFilter,
                        }"
                        class="dropdownItem"
                      >
                        See All
                      </div>
                      <div
                        v-for="suggestion in suggestions"
                        :key="suggestion"
                        @click="selectFilter(suggestion.display_name)"
                        class="dropdownItem"
                        :class="{
                          selected: suggestion.display_name == selectedSuggestionFilter,
                        }"
                      >
                        {{ suggestion.display_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-for="suggestion in getFilteredSuggestions"
                  :key="suggestion"
                  class="suggestion"
                  :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                >
                  <div v-if="suggestion.items && suggestion.items.length != 0">
                    <div class="suggestionHeaderWrapper">
                      <p class="suggestionHeader">
                        <span v-if="suggestion.type == 'temperature'"
                          >It's {{ temperature }} °F in {{ selectedStore.city }}.</span
                        >
                        {{ suggestion.prompt }}
                      </p>
                      <a
                        @click="getSurpriseSuggestions"
                        v-if="suggestion.type == 'surprise'"
                        class="surpriseButton"
                        href="javascript:;"
                      >
                        <p>SURPRISE ME</p>
                      </a>
                    </div>
                    <swiper
                      :navigation="true"
                      :slidesPerView="'auto'"
                      :spaceBetween="15"
                      :slidesOffsetBefore="windowWidth > 768 ? 0 : 20"
                      :slidesOffsetAfter="windowWidth > 768 ? 0 : 20"
                      :modules="modules"
                      class="mySwiper"
                    >
                      <swiper-slide
                        @click="getItemData(item, getCategory(item.category_id), 'add')"
                        v-for="item in suggestion.type == 'surprise' ? surpriseSuggestions : suggestion.items"
                        :key="item.item_id"
                        class="suggestionItem"
                        :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
                      >
                        <div v-if="checkIfImageIsVisible" class="itemImageWrapper">
                          <img :src="item.image_urls.thumbnail" :alt="item.name" loading="lazy" />
                        </div>
                        <div class="suggestionItemInfo">
                          <p class="suggestionItemName">{{ item.name }}</p>
                          <p class="suggestionItemDescription">
                            {{ item.short_desc }}
                          </p>
                          <p v-if="checkIfPriceVisible(item.variants[0].display_price)" class="suggestionItemPrice">
                            {{ formatPrice(item.variants[0].display_price) }}
                          </p>
                        </div>
                      </swiper-slide>
                    </swiper>
                  </div>
                </div>
              </div>
              <div
                class="category"
                :style="{
                  'scroll-margin-top': branding.category_placement == 'top' ? '80px' : '60px',
                }"
                v-for="(category, index) in getAvailableMenus[selectedMenuIndex].categories"
                :key="category.category_id"
                :id="category.category_id"
              >
                <div class="categoryInfo" :class="{ parentCategory: category.categories?.length != 0 }">
                  <div>
                    <div v-if="branding?.display_options?.show_category_headers" class="categoryImageWrapper">
                      <img
                        class="categoryMainImage"
                        :src="getCategoryImage(category.image_urls.standard)"
                        :alt="category.name"
                      />
                    </div>
                    <h2 v-if="!branding?.display_options?.hide_category_names !== false" class="categoryName">
                      {{ category.name }}
                    </h2>
                    <p v-if="category.short_desc" class="categoryDescription">
                      {{ category.short_desc }}
                    </p>
                  </div>
                  <div class="filterButton" v-if="index == 0 && selectedStore?.extra?.enable_allergen_filter">
                    <button
                      class="filter"
                      :style="{ width: selectedAllergens.length > 0 || selectedItemClasses.length > 0 ? '150px' : '' }"
                      aria-label="Open filter options"
                    >
                      <svg
                        @click="toggleFilterModal"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.4556 15.0874C11.0903 15.0874 10.7555 14.9961 10.4512 14.8135C10.1523 14.6364 9.91162 14.3957 9.729 14.0913C9.54639 13.7925 9.45508 13.4604 9.45508 13.0952C9.45508 12.73 9.54639 12.3979 9.729 12.0991C9.91162 11.7948 10.1523 11.554 10.4512 11.377C10.7555 11.1943 11.0903 11.103 11.4556 11.103C11.8208 11.103 12.1528 11.1943 12.4517 11.377C12.756 11.554 12.9967 11.7948 13.1738 12.0991C13.3564 12.3979 13.4478 12.73 13.4478 13.0952C13.4478 13.4604 13.3564 13.7925 13.1738 14.0913C12.9967 14.3957 12.756 14.6364 12.4517 14.8135C12.1528 14.9961 11.8208 15.0874 11.4556 15.0874ZM11.4556 14.0664C11.7267 14.0664 11.9564 13.9723 12.1445 13.7842C12.3327 13.596 12.4268 13.3664 12.4268 13.0952C12.4268 12.8185 12.3327 12.5889 12.1445 12.4062C11.9564 12.2181 11.7267 12.124 11.4556 12.124C11.1844 12.124 10.9548 12.2181 10.7666 12.4062C10.5785 12.5889 10.4844 12.8185 10.4844 13.0952C10.4844 13.3664 10.5785 13.596 10.7666 13.7842C10.9548 13.9723 11.1844 14.0664 11.4556 14.0664ZM10.1357 12.4229V13.7593H0.780762C0.598145 13.7593 0.44043 13.6956 0.307617 13.5684C0.180339 13.4355 0.116699 13.2778 0.116699 13.0952C0.116699 12.9071 0.180339 12.7493 0.307617 12.6221C0.44043 12.4893 0.598145 12.4229 0.780762 12.4229H10.1357ZM16.2036 12.4229C16.3752 12.4229 16.5246 12.4893 16.6519 12.6221C16.7791 12.7493 16.8428 12.9071 16.8428 13.0952C16.8428 13.2778 16.7791 13.4355 16.6519 13.5684C16.5246 13.6956 16.3752 13.7593 16.2036 13.7593H12.8999V12.4229H16.2036ZM5.59521 10.0239C5.22998 10.0239 4.89518 9.93262 4.59082 9.75C4.29199 9.56738 4.05127 9.32666 3.86865 9.02783C3.69157 8.72347 3.60303 8.38867 3.60303 8.02344C3.60303 7.6582 3.69157 7.32617 3.86865 7.02734C4.05127 6.72298 4.29199 6.48226 4.59082 6.30518C4.89518 6.12256 5.22998 6.03125 5.59521 6.03125C5.96045 6.03125 6.29248 6.12256 6.59131 6.30518C6.89567 6.48226 7.13639 6.72298 7.31348 7.02734C7.49609 7.32617 7.5874 7.6582 7.5874 8.02344C7.5874 8.38867 7.49609 8.72347 7.31348 9.02783C7.13639 9.32666 6.89567 9.56738 6.59131 9.75C6.29248 9.93262 5.96045 10.0239 5.59521 10.0239ZM5.59521 8.99463C5.87191 8.99463 6.10156 8.90055 6.28418 8.7124C6.47233 8.52425 6.56641 8.2946 6.56641 8.02344C6.56641 7.74674 6.47233 7.51709 6.28418 7.33447C6.10156 7.14632 5.87191 7.05225 5.59521 7.05225C5.32406 7.05225 5.0944 7.14632 4.90625 7.33447C4.7181 7.51709 4.62402 7.74674 4.62402 8.02344C4.62402 8.2946 4.7181 8.52425 4.90625 8.7124C5.0944 8.90055 5.32406 8.99463 5.59521 8.99463ZM0.747559 7.35107H4.16748V8.6875H0.747559C0.581543 8.6875 0.434896 8.62386 0.307617 8.49658C0.180339 8.3693 0.116699 8.21159 0.116699 8.02344C0.116699 7.83529 0.180339 7.67757 0.307617 7.55029C0.434896 7.41748 0.581543 7.35107 0.747559 7.35107ZM16.1704 7.35107C16.3586 7.35107 16.5163 7.41748 16.6436 7.55029C16.7764 7.67757 16.8428 7.83529 16.8428 8.02344C16.8428 8.21159 16.7764 8.3693 16.6436 8.49658C16.5163 8.62386 16.3586 8.6875 16.1704 8.6875H6.91504V7.35107H16.1704ZM11.4556 4.94385C11.0903 4.94385 10.7555 4.85531 10.4512 4.67822C10.1523 4.49561 9.91162 4.25488 9.729 3.95605C9.54639 3.65169 9.45508 3.31689 9.45508 2.95166C9.45508 2.58643 9.54639 2.25439 9.729 1.95557C9.91162 1.6512 10.1523 1.40771 10.4512 1.2251C10.7555 1.04248 11.0903 0.951172 11.4556 0.951172C11.8208 0.951172 12.1528 1.04248 12.4517 1.2251C12.756 1.40771 12.9967 1.6512 13.1738 1.95557C13.3564 2.25439 13.4478 2.58643 13.4478 2.95166C13.4478 3.31689 13.3564 3.65169 13.1738 3.95605C12.9967 4.25488 12.756 4.49561 12.4517 4.67822C12.1528 4.85531 11.8208 4.94385 11.4556 4.94385ZM11.4556 3.92285C11.7267 3.92285 11.9564 3.82878 12.1445 3.64062C12.3327 3.44694 12.4268 3.21452 12.4268 2.94336C12.4268 2.6722 12.3327 2.44255 12.1445 2.25439C11.9564 2.06624 11.7267 1.97217 11.4556 1.97217C11.1844 1.97217 10.9548 2.06624 10.7666 2.25439C10.5785 2.44255 10.4844 2.6722 10.4844 2.94336C10.4844 3.21452 10.5785 3.44694 10.7666 3.64062C10.9548 3.82878 11.1844 3.92285 11.4556 3.92285ZM10.1772 2.2876V3.62402H0.780762C0.598145 3.62402 0.44043 3.56038 0.307617 3.43311C0.180339 3.30029 0.116699 3.13981 0.116699 2.95166C0.116699 2.76904 0.180339 2.6141 0.307617 2.48682C0.44043 2.354 0.598145 2.2876 0.780762 2.2876H10.1772ZM16.2036 2.2876C16.3752 2.2876 16.5246 2.354 16.6519 2.48682C16.7791 2.6141 16.8428 2.76904 16.8428 2.95166C16.8428 3.13981 16.7791 3.30029 16.6519 3.43311C16.5246 3.56038 16.3752 3.62402 16.2036 3.62402H12.7837V2.2876H16.2036Z"
                          fill="#737373"
                        />
                      </svg>
                      <p
                        @click="toggleFilterModal"
                        tabindex="0"
                        aria-label="Filters"
                        @keydown.enter="toggleFilterModal"
                      >
                        Filters
                      </p>
                      <div
                        v-if="selectedAllergens.length > 0 || selectedItemClasses.length > 0"
                        style="display: flex; gap: 10px"
                      >
                        <p>({{ selectedAllergens.length + selectedItemClasses.length }})</p>
                        <svg
                          @click="clearFilter"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          tabindex="0"
                          @keydown.enter="clearFilter"
                        >
                          <path
                            d="M10.543 19.7441C9.20182 19.7441 7.9388 19.487 6.75391 18.9727C5.57552 18.4648 4.53385 17.7617 3.62891 16.8633C2.73047 15.9583 2.02409 14.9167 1.50977 13.7383C1.00195 12.5534 0.748047 11.2904 0.748047 9.94922C0.748047 8.60807 1.00195 7.34831 1.50977 6.16992C2.02409 4.98503 2.73047 3.94336 3.62891 3.04492C4.52734 2.13997 5.56576 1.43359 6.74414 0.925781C7.92904 0.411458 9.19206 0.154297 10.5332 0.154297C11.8743 0.154297 13.1374 0.411458 14.3223 0.925781C15.5072 1.43359 16.5488 2.13997 17.4473 3.04492C18.3457 3.94336 19.0521 4.98503 19.5664 6.16992C20.0807 7.34831 20.3379 8.60807 20.3379 9.94922C20.3379 11.2904 20.0807 12.5534 19.5664 13.7383C19.0521 14.9167 18.3457 15.9583 17.4473 16.8633C16.5488 17.7617 15.5072 18.4648 14.3223 18.9727C13.1439 19.487 11.8841 19.7441 10.543 19.7441ZM7.25195 13.875C7.43424 13.875 7.59049 13.8099 7.7207 13.6797L10.543 10.8477L13.375 13.6797C13.4987 13.8099 13.6517 13.875 13.834 13.875C14.0098 13.875 14.1562 13.8132 14.2734 13.6895C14.3971 13.5658 14.459 13.4193 14.459 13.25C14.459 13.0612 14.3971 12.9115 14.2734 12.8008L11.4316 9.95898L14.2832 7.11719C14.4069 6.98698 14.4688 6.83398 14.4688 6.6582C14.4688 6.48893 14.4069 6.3457 14.2832 6.22852C14.166 6.10482 14.0195 6.04297 13.8438 6.04297C13.6745 6.04297 13.528 6.10807 13.4043 6.23828L10.543 9.08008L7.70117 6.24805C7.57096 6.12435 7.42122 6.0625 7.25195 6.0625C7.07617 6.0625 6.92643 6.12109 6.80273 6.23828C6.68555 6.35547 6.62695 6.4987 6.62695 6.66797C6.62695 6.83724 6.6888 6.98698 6.8125 7.11719L9.66406 9.95898L6.8125 12.8008C6.6888 12.931 6.62695 13.0807 6.62695 13.25C6.62695 13.4193 6.68555 13.5658 6.80273 13.6895C6.92643 13.8132 7.07617 13.875 7.25195 13.875Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                    </button>
                  </div>
                </div>
                <div v-if="category.categories?.length != 0" class="subCategories">
                  <div
                    class="category"
                    v-for="(subCategory, index) in category.categories"
                    :key="subCategory.category_id"
                    :id="subCategory.category_id"
                  >
                    <div class="categoryInfo">
                      <h2 class="categoryName">{{ subCategory.name }}</h2>
                      <p v-if="subCategory.short_desc" class="categoryDescription">
                        {{ subCategory.short_desc }}
                      </p>
                    </div>
                    <div class="items">
                      <div
                        @click="
                          item.type == 'marketing' ? openMarketingBox(item.url) : getItemData(item, subCategory, 'add')
                        "
                        class="item"
                        v-for="item in subCategory.items"
                        :key="item.item_id"
                      >
                        <ItemCell
                          :item="item"
                          :category="subCategory"
                          :index="index"
                          @getItemData="getItemData"
                          @changeQty="changeQty"
                          :orderData="orderData"
                          :qtyLoading="qtyLoading"
                          :selectedItemId="selectedItemId"
                          :quickAddLoadingItemId="quickAddLoadingItemId"
                          :fillScreenAnimation="fillScreenAnimation"
                          :fillScreenItemId="fillScreenItemId"
                          :flyToCardItemId="flyToCardItemId"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="items" role="list">
                  <div
                    role="listitem"
                    aria-label="Item"
                    @click="item.type == 'marketing' ? openMarketingBox(item.url) : getItemData(item, category, 'add')"
                    @keyup.enter="
                      item.type == 'marketing' ? openMarketingBox(item.url) : getItemData(item, category, 'add')
                    "
                    class="item"
                    v-for="item in category.items"
                    :key="item.item_id"
                    tabindex="0"
                  >
                    <ItemCell
                      :item="item"
                      :category="category"
                      :index="index"
                      @getItemData="getItemData"
                      @changeQty="changeQty"
                      :orderData="orderData"
                      :qtyLoading="qtyLoading"
                      :selectedItemId="selectedItemId"
                      :quickAddLoadingItemId="quickAddLoadingItemId"
                      :fillScreenAnimation="fillScreenAnimation"
                      :fillScreenItemId="fillScreenItemId"
                      :flyToCardItemId="flyToCardItemId"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="emptyMenu">
      <p>
        There is no active menu for the selected date and time. <br />
        <a class="clear" @click="toggleDateAndTimeModal" href="javascript:;">
          <p>CHANGE ORDER DATE AND TIME</p>
        </a>
      </p>
    </div>
    <FooterView />
  </div>
</template>

<script>
import formattingMixins from '@/mixins/formattingMixins'
import normalizeAddons from '@/mixins/normalizeAddons'
import trackMainRoutes from '@/mixins/trackMainRoutes'
import menuItemImageVisibility from '@/mixins/menuItemImageVisibility'

import { mapState, mapMutations } from 'vuex'

import HeroView from '@/components/Main/Layout/HeroView.vue'
import FooterView from '@/components/Main/Layout/FooterView.vue'
import LoaderView from '@/components/Loaders/LoaderView.vue'
import DateAndTimeModal from '@/components/Modals/StoreModals/DateAndTimeModal.vue'
import WithAddons from '@/components/Modals/ItemModals/WithAddons.vue'
import CartModal from '@/components/Modals/CartModals/CartModal.vue'
import PendingDiscountModal from '@/components/Modals/StoreModals/PendingDiscountModal.vue'
import ItemCell from '@/components/Main/Menu/ItemCell.vue'
import FilterModalAllergen from '@/components/Modals/FilterModals/FilterModalAllergen.vue'

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { Navigation } from 'swiper'
import 'swiper/css/navigation'
import moment from 'moment'

import DOMPurify from 'dompurify'
import allergensMixins from '@/mixins/allergensMixins'
import menusApi from '@/api/menusApi'
import ordersApi from '@/api/ordersApi'
import externalApi from '@/api/externalApi'
import customersApi from '@/api/customersApi.js'

export default {
  data() {
    return {
      storeId: null,
      menus: null,
      modules: [Navigation],
      activeCategoryIndex: 0,
      activeCategoryId: null,
      activeSubCategoryId: null,
      search: '',
      searchedItems: null,
      dateAndTimeModalIsOpen: true,
      withAddonsModalIsOpen: false,
      itemData: null,
      normalizedAddons: null,
      showLoader: false,
      swiperSlideData: {
        activeSlide: 0,
        isBeginning: true,
        isEnd: false,
      },
      itemModalMode: 'add',
      editItemData: null,
      swiper: null,
      innerWidth: window.innerWidth,
      cartViewIsOpen: false,
      suggestions: [],
      temperature: null,
      selectedSuggestionFilter: 'See All',
      filterDropdownIsOpen: false,
      selectedMenuIndex: 0,
      surpriseSuggestions: [],
      slidesPerView: 3,
      pendingDiscountModalIsOpen: false,
      pendingDiscountData: null,
      selectedItemId: null,
      selectedItemName: null,
      selectedItemIndex: null,
      removeItemModalIsOpen: false,
      qtyLoading: false,
      quickAddLoadingItemId: null,
      fillScreenAnimation: false,
      fillScreenItemId: null,
      flyToCardItemId: null,
      windowWidth: window.innerWidth,
      filterModalIsOpen: false,
      selectedFilters: [],
      preferencesAllergens: [],
      preferencesItemClasses: [],
      selectedAllergens: [],
      selectedItemClasses: [],
      filterApplied: false,
    }
  },
  components: {
    HeroView,
    Swiper,
    SwiperSlide,
    LoaderView,
    DateAndTimeModal,
    WithAddons,
    FooterView,
    CartModal,
    PendingDiscountModal,
    ItemCell,
    FilterModalAllergen,
  },
  watch: {
    selectedStore() {
      let customerId = localStorage.getItem('customerId')
      if (customerId && this.selectedStore?.extra?.enable_allergen_filter == true) {
        this.getPreferences()
      }
      this.getTemperature()
    },
    selectedHour() {
      this.getMenus()
    },
    loggedIn() {
      if (this.loggedIn == true && this.selectedStore?.extra?.enable_allergen_filter == true) {
        this.getPreferences()
      }
    },
    orderData(newVal, oldVal) {
      if (newVal && oldVal == null && this.menus) {
        // if there is an active order and deepLinkItemId, add it to the cart
        let deepLinkItemId = localStorage.getItem('deepLinkItemId')
        if (this.orderData && deepLinkItemId) {
          this.addDeepLinkItemToCart()
        }
      }
    },
    menus(newVal, oldVal) {
      if (newVal && oldVal == null && this.orderData) {
        // if there is an active order and deepLinkItemId, add it to the cart
        let deepLinkItemId = localStorage.getItem('deepLinkItemId')
        if (this.menus && deepLinkItemId) {
          this.addDeepLinkItemToCart()
        }
      }
    },
  },
  mixins: [formattingMixins, normalizeAddons, menuItemImageVisibility, allergensMixins],
  // spread operator used because beforeRouteLeave is not working with the mixin
  ...trackMainRoutes,
  computed: {
    ...mapState([
      'storeConfig',
      'loggedIn',
      'selectedStore',
      'branding',
      'cartIsOpen',
      'selectedHour',
      'selectedDay',
      'dayAndTimeSelected',
      'cookies',
      'orderData',
    ]),
    getAvailableMenus() {
      // filter out menus that dont have categories
      let availableMenus = this.menus.filter((menu) => menu.categories.length > 0)
      return availableMenus
    },
    getFilteredSuggestions() {
      if (this.selectedSuggestionFilter == 'See All') {
        return this.suggestions
      } else {
        return this.suggestions.filter(
          (suggestion) => suggestion.display_name == this.selectedSuggestionFilter && suggestion.enabled
        )
      }
    },
    quickAddable() {
      // if item has size
      if (this.normalizedAddons.sizes) {
        return false
        // if item has styles
      } else if (this.normalizedAddons.styles) {
        return false
        // if item has modifiers
      } else if (this.normalizedAddons.addOn.pick_lists.length > 0) {
        return false
      } else {
        return true
      }
    },
    getPurifiedBody() {
      // only allow br, strong, and a tags
      const allowedTags = ['br', 'strong', 'a', 'n']
      const allowedAttributes = ['href', 'target']
      const purifiedBody = DOMPurify.sanitize(this.selectedStore.promo_text, {
        ALLOWED_TAGS: allowedTags,
        ALLOWED_ATTR: allowedAttributes,
      })
      return purifiedBody
    },
    checkIfMenuVisible() {
      if (this.menus && this.getAvailableMenus) {
        let menusHaveCategories = this.getAvailableMenus.some((menu) => menu.categories.length > 0)
        if (this.getAvailableMenus.length != 0 && menusHaveCategories) {
          return true
        }
      }
      return false
    },
    getTopCategories() {
      const categories = []

      const selectedMenu = this.menus[this.selectedMenuIndex]
      for (const category of selectedMenu.categories) {
        if (category.categories && category.categories.length !== 0) {
          categories.push(...category.categories)
        } else {
          categories.push(category)
        }
      }

      return categories
    },
  },
  methods: {
    ...mapMutations([
      'SET_ORDER_DATA',
      'SET_TOASTER',
      'SET_CART_IS_OPEN',
      'SET_COOKIES',
      'SET_DAY_AND_TIME_SELECTED',
      'SET_SELECTED_DAY',
      'SET_SELECTED_HOUR',
      'SET_SELECTED_ADDRESS',
      'SET_ITEM_TOASTER',
    ]),
    checkIfPriceVisible(price) {
      if ('hide_price_if_zero' in this.branding?.display_options) {
        if (price == 0 && this.branding?.display_options?.hide_price_if_zero) {
          return false
        }
      }
      return true
    },
    addDeepLinkItemToCart() {
      let deepLinkItemId = localStorage.getItem('deepLinkItemId')
      // find item in this.menus categories items
      let itemData = null
      let categoryId = null
      for (const menu of this.menus) {
        for (const category of menu.categories) {
          for (const item of category.items) {
            if (item.item_id == deepLinkItemId) {
              itemData = item
              categoryId = category.category_id
              break
            }
          }
        }
      }
      // if item is found, add it to the cart
      if (itemData) {
        this.getItemData(itemData, this.getCategory(categoryId), 'add', 'deepLink')
        localStorage.removeItem('deepLinkItemId')
      }
    },
    getCategoryImage(url) {
      return url.replace('600,450', '1200,900')
    },
    getCategory(id) {
      let categoryData
      this.menus.forEach((menu) => {
        menu.categories.forEach((category) => {
          if (category.category_id === id) {
            categoryData = category
          }
        })
      })
      if (!categoryData) {
        return { category_id: id }
      }
      return categoryData
    },
    getTotalQuantity(itemId) {
      let totalQuantity = 0
      let multipleItems = false

      for (let i = 0; i < this.orderData.order.items.length; i++) {
        const item = this.orderData.order.items[i]

        if (item.item_id === itemId) {
          totalQuantity += item.quantity

          if (totalQuantity > item.quantity) {
            multipleItems = true
          }
        }
      }
      return {
        totalQuantity,
        multipleItems,
      }
    },
    trackItemClicks(category, item) {
      window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: 'USD',
          value: item.variants[0].price / 100,
          items: [
            {
              item_id: item.item_id,
              item_name: item.name,
              item_category: category.name || '',
              location_id: this.selectedStore.name,
              price: item.variants[0].price / 100,
            },
          ],
        },
      })
    },
    trackAddToCart(item) {
      window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'USD',
          value: item.variants[0].price / 100,
          items: [
            {
              item_id: item.item_id,
              item_name: item.name,
              price: item.variants[0].price / 100,
              location_id: this.selectedStore.name,
            },
          ],
        },
      })
    },
    getSurpriseSuggestions() {
      // find the suggestion with type 'surprise'
      let surprise = this.suggestions.find((suggestion) => suggestion.type == 'surprise')
      let randomItems = []
      // get 3 random items from the surprise suggestion.items and make sure they are not the same
      for (let i = 0; i < 3; i++) {
        let randomItem = surprise.items[Math.floor(Math.random() * surprise.items.length)]
        if (randomItems.includes(randomItem)) {
          i--
        } else {
          randomItems.push(randomItem)
        }
      }
      this.surpriseSuggestions = randomItems
    },
    openMarketingBox(url) {
      window.open(url, '_blank')
    },
    openDiscountModal(data) {
      this.pendingDiscountData = data
      this.togglePendingDiscountModal()
    },
    selectFilter(filter) {
      this.selectedSuggestionFilter = filter
      this.toggleFilterDropdown()
    },
    formatTime(time) {
      return moment(this.calculateTimeToHour(time), 'HH:mm:ss').format('h:mm A')
    },
    toggleDateAndTimeModal() {
      this.dateAndTimeModalIsOpen = !this.dateAndTimeModalIsOpen
    },
    toggleWithAddonsModal() {
      setTimeout(() => {
        this.fillScreenItemId = null
        this.fillScreenAnimation = false
      }, 800)
      this.withAddonsModalIsOpen = !this.withAddonsModalIsOpen
    },
    toggleFilterDropdown() {
      this.filterDropdownIsOpen = !this.filterDropdownIsOpen
    },
    toggleCartViewModal() {
      this.SET_CART_IS_OPEN(!this.cartIsOpen)
    },
    togglePendingDiscountModal() {
      this.pendingDiscountModalIsOpen = !this.pendingDiscountModalIsOpen
    },
    toggleRemoveItemModal() {
      this.removeItemModalIsOpen = !this.removeItemModalIsOpen
    },
    openEditWithAddons(item) {
      this.itemModalMode = 'edit'
      this.getItemData(item, this.getCategory(item.category_id), 'edit')
    },
    getActiveSlide(event) {
      this.swiperSlideData.activeSlide = event.activeIndex
      this.swiperSlideData.isBeginning = event.isBeginning
      this.swiperSlideData.isEnd = event.isEnd
    },
    searchItems() {
      // scroll to top
      document.querySelector('.menu').scrollTo(0, 0)
      if (this.search.length == 0) {
        this.searchedItems = null
      }
      if (this.search.length > 2) {
        let searchResults = []
        this.menus[this.selectedMenuIndex].categories.forEach((category) => {
          if (category.categories?.length != 0) {
            category.categories.forEach((subCategory) => {
              subCategory.items.forEach((item) => {
                if (item.name?.toLowerCase().includes(this.search.toLowerCase())) {
                  let itemData = item
                  itemData.category = subCategory
                  searchResults.push(itemData)
                }
              })
            })
          } else {
            category.items.forEach((item) => {
              if (item.name?.toLowerCase().includes(this.search.toLowerCase())) {
                let itemData = item
                itemData.category = category
                searchResults.push(itemData)
              }
            })
          }
        })
        if (searchResults.length > 0) {
          this.searchedItems = searchResults
        } else {
          this.searchedItems = []
        }
      }
    },
    clearSearch() {
      this.search = ''
      this.searchedItems = null
    },
    calculateTimeToHour(h) {
      return ('0' + Math.floor(parseInt(h) / 60)).slice(-2) + ':' + ('0' + (parseInt(h) % 60)).slice(-2)
    },
    getMenus() {
      let storeId = this.storeId
      if (storeId.includes(' ')) {
        storeId = storeId.replace(' ', '%20')
      }

      let serviceTypeID = this.$route.query.service_type || localStorage.getItem('selectedServiceId')
      if (this.$route.query.service_type) {
        localStorage.setItem('selectedServiceId', this.$route.query.service_type)
      } else {
        localStorage.removeItem('selectedServiceId')
      }

      let payload = {
        skip_pick_lists: true,
        service_type_id: serviceTypeID,
      }

      if (!serviceTypeID) {
        delete payload.service_type_id
      }

      if (this.selectedDay && this.selectedHour) {
        let time = this.selectedHour.hour == 'ASAP' ? this.selectedHour.asapTime : this.selectedHour.hour
        payload.ready_ts = this.selectedDay.date + ' ' + time
      }
      menusApi
        .getMenus(this.storeId, payload)
        .then((response) => {
          this.menus = response.data.data
          if (this.branding.display_options?.marketing_box?.enable) {
            let marketing = this.branding.display_options?.marketing_box
            marketing.type = 'marketing'
            if (this.menus[0].categories.length > 0) {
              if (this.menus[0].categories[0].items.length > 3) {
                // push marketing box after the 3rd item
                this.menus[0].categories[0].items.splice(4, 0, marketing)
              } else {
                // push marketing box to the end of the list
                this.menus[0].categories[0].items.push(marketing)
              }
            }
          }
          this.SET_COOKIES(response.data.cookies)
          let bundledMenu = []
          this.menus.forEach((menu) => {
            menu.available = true
            menu.categories.forEach((category) => {
              if (category.categories?.length != 0) {
                category.categories.forEach((subCategory) => {
                  subCategory.menu_id = menu.menu_id
                  subCategory.hours = menu.hours
                  subCategory.items.forEach((item) => {
                    item.menu_id = menu.menu_id
                  })
                })
              } else {
                category.menu_id = menu.menu_id
                category.hours = menu.hours
                category.items.forEach((item) => {
                  item.menu_id = menu.menu_id
                })
              }
            })
            // if bundle categories is true
            if (this.branding?.display_options?.collapse_menu_categories) {
              menu.categories.forEach((category) => {
                bundledMenu.push(category)
              })
              menu.categories = bundledMenu
            }
          })
          if (
            this.branding.suggestions &&
            this.branding.suggestions.lists &&
            this.branding.suggestions.lists.length > 0
          ) {
            this.suggestions = []
            this.branding.suggestions.lists.forEach((suggestion) => {
              if (suggestion.type == 'temperature') {
                if (suggestion.limit_type == 'less' && this.temperature >= suggestion.limit) {
                  return
                }
                if (suggestion.limit_type == 'more' && this.temperature <= suggestion.limit) {
                  return
                }
              }
              let suggestionItems = []
              if (this.menus.length != 0) {
                this.menus.forEach((menu) => {
                  menu.categories.forEach((category) => {
                    category.items.forEach((item) => {
                      if (item.classes && item.classes[suggestion.class.name]) {
                        // if item is already in the suggestion list, don't add it again
                        if (suggestionItems.find((suggestionItem) => suggestionItem.item_id == item.item_id)) {
                          return
                        }
                        item.category_id = category.category_id
                        suggestionItems.push(item)
                      }
                    })
                  })
                })
                suggestion.items = suggestionItems
                if (suggestion.items.length > 0) {
                  this.suggestions.push(suggestion)
                  this.selectedSuggestionFilter = this.suggestions[0].display_name
                }
              }
            })
            let surprise = this.suggestions.find((suggestion) => suggestion.type == 'surprise')
            if (surprise) {
              this.getSurpriseSuggestions()
            }
          }
          this.activeCategoryId = this.getAvailableMenus[this.selectedMenuIndex]?.categories[0].category_id
        })
        .catch((error) => {
          console.log(error)
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    checkInnerWidth(innerWidth) {
      if (innerWidth >= 768) {
        this.slidesPerView = 3
      }
      if (innerWidth < 768) {
        this.slidesPerView = 2
      }
      if (innerWidth <= 500) {
        this.slidesPerView = 1
      }
    },
    scrollToCategory(categoryId, index) {
      this.clearSearch()
      this.activeCategoryIndex = index
      let category = document.getElementById(categoryId)
      category.setAttribute('tabindex', '0')
      category.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
      setTimeout(() => {
        category.focus()
      }, 500)
    },
    updateActiveCategory(event) {
      if (this.searchedItems) return
      let categories
      // check if categories are on top
      if ((this.branding && this.branding.category_placement == 'top') || this.innerWidth <= 768) {
        // get categories
        categories = this.getTopCategories
        // go through categories
        categories.forEach((category) => {
          // get category's position
          let categoryElement = document.getElementById(category.category_id)
          let categoryPosition = categoryElement?.getBoundingClientRect()
          if (categoryPosition?.top <= 310) {
            this.activeCategoryId = category.category_id
            this.activeSubCategoryId = null
          }
        })
        // find category's index
        let categoryIndex = categories.findIndex((cat) => cat.category_id == this.activeCategoryId)
        // only slide if category is not active
        if (this.activeCategoryIndex != categoryIndex) {
          this.activeCategoryIndex = categoryIndex
          this.swiper.slideTo(categoryIndex - 1, 500, false)
        }
      }
      // check if categories are on side
      else {
        // get categories
        categories = this.menus[this.selectedMenuIndex].categories
        // go through categories
        categories.forEach((category) => {
          // check if there are subcategories
          if (category.categories?.length != 0) {
            category.categories.forEach((subCategory) => {
              let subCategoryElement = document.getElementById(subCategory.category_id)
              let subCategoryPosition = subCategoryElement?.getBoundingClientRect()
              if (subCategoryPosition?.top <= 310) {
                this.activeCategoryId = category.category_id
                this.activeSubCategoryId = subCategory.category_id
              }
            })
          } else {
            let categoryElement = document.getElementById(category.category_id)
            let categoryPosition = categoryElement?.getBoundingClientRect()
            if (categoryPosition?.top <= 310) {
              this.activeCategoryId = category.category_id
              this.activeSubCategoryId = null
            }
          }
        })
      }
      // if user scrolled to the bottom of the page, set the last category as active
      let target = event.target
      if (target.scrollHeight - target.scrollTop === target.clientHeight) {
        this.activeCategoryIndex = categories.length - 1
      }
    },
    onSwiper(swiper) {
      this.swiper = swiper
    },
    changeMenu(index) {
      this.selectedMenuIndex = index
      this.swiper.slideTo(0, 500, false)
    },
    getItemData(item, category, mode, from) {
      // if orderData && dayAndTimeSelected false open date and time modal
      if (!this.orderData && !this.dayAndTimeSelected) {
        this.toggleDateAndTimeModal()
        return
      }
      if (from == 'quickAdd') {
        this.quickAddLoadingItemId = item.item_id
        this.fillScreenItemId = item.item_id
        this.qtyLoading = false
      }
      if (from != 'quickAdd') {
        this.showLoader = true
      }
      if (process.env.VUE_APP_GTM_ID && mode == 'add') {
        // GTM track item clicks
        this.trackItemClicks(category, item)
      }
      if (mode == 'edit') {
        this.editItemData = item
        this.editItemData.menu_id = item.menu_id
      } else {
        this.itemModalMode = 'add'
      }
      let storeId = localStorage.getItem('selectedStoreId')
      if (storeId.includes(' ')) {
        storeId = storeId.replace(' ', '%20')
      }
      let time = this.selectedHour.hour == 'ASAP' ? this.selectedHour.asapTime : this.selectedHour.hour
      let payload = {
        ready_ts: this.selectedDay.date + ' ' + time,
      }
      menusApi
        .getItem(storeId, item.menu_id, category.category_id, item.item_id, payload)
        .then((response) => {
          this.itemData = response.data.data
          this.SET_COOKIES(response.data.cookies)
          this.itemData.menu_id = item.menu_id
          this.normalizedAddons = this.normalizeAddons(response.data.data)
          if ((from == 'quickAdd' || from == 'deepLink') && this.quickAddable) {
            this.addToCart()
            if (from == 'quickAdd') this.flyToCardItemId = item.item_id
            if (process.env.VUE_APP_GTM_ID || process.env.VUE_APP_GA4_ID) {
              // GTM track add to cart
              this.trackAddToCart(item)
            }
          } else {
            this.fillScreenAnimation = true
            this.showLoader = false
            this.toggleWithAddonsModal()
            setTimeout(() => {
              this.quickAddLoadingItemId = null
              this.flyToCardItemId = null
            }, 300)
          }
        })
        .catch((error) => {
          console.log(error)
          this.showLoader = false
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    addToCart() {
      let itemPayload = {
        menu_id: parseInt(this.itemData.menu_id),
        quantity: 1,
        item_id: this.itemData.item_id,
        category_id: this.itemData.category_id,
        child_items: [],
        comment: '',
        size_id: null,
      }
      let orderId = this.orderData.order.order_id
      let customerId = localStorage.getItem('customerId')
      let payload = {
        customer_id: this.loggedIn ? customerId : localStorage.getItem('guestCustomerId'),
        items: [itemPayload],
      }
      ordersApi
        .addItemToCart(orderId, payload)
        .then((response) => {
          this.SET_ORDER_DATA(response.data.data)
          this.SET_COOKIES(response.data.cookies)
          this.selectedItemId = this.itemData.item_id
          let toasterData = {
            show: true,
            message: 'Item added to cart',
          }
          this.showLoader = false
          this.quickAddLoadingItemId = null
          this.flyToCardItemId = null
          this.SET_ITEM_TOASTER(toasterData)
        })
        .catch((error) => {
          if (error.response.data.status == 403) {
            let toasterData = {
              show: true,
              message: 'Your session is expired. Please login again.',
            }
            this.SET_TOASTER(toasterData)
            return
          }
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later.',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    calculateFullPrice(item) {
      let itemPrice = item.extended_price
      if (item.child_items) {
        item.child_items.forEach((childItem) => {
          itemPrice += childItem.extended_price
          if (childItem.child_items) {
            childItem.child_items.forEach((childItem) => {
              itemPrice += childItem.extended_price
              if (childItem.child_items) {
                childItem.child_items.forEach((childItem) => {
                  itemPrice += childItem.extended_price
                })
              }
            })
          }
        })
      }
      return itemPrice
    },
    removeItemClicked(item) {
      this.removeItem(item)
    },
    trackRemoveFromCart(item) {
      window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
          currency: 'USD',
          value: this.calculateFullPrice(item) / 100,
          items: [
            {
              item_id: item.item_id,
              item_name: item.item_name,
              price: this.calculateFullPrice(item) / 100,
              quantity: item.display_quantity,
              location_id: this.selectedStore.name,
            },
          ],
        },
      })
    },
    removeItem(item) {
      let orderId = this.orderData.order.order_id
      ordersApi
        .removeItemFromCart(orderId, item.order_item_id)
        .then((response) => {
          this.qtyLoading = false
          if (process.env.VUE_APP_GTM_ID || process.env.VUE_APP_GA4_ID) {
            // GTM track remove from cart
            this.trackRemoveFromCart(item)
          }
          this.SET_ORDER_DATA(response.data.data)
          let toasterData = {
            show: true,
            message: 'Item removed from cart',
          }
          this.SET_ITEM_TOASTER(toasterData)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          this.qtyLoading = false
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again.',
          }
          this.SET_TOASTER(toasterData)
          console.log(error)
        })
    },
    childItems(child_items) {
      let childItems = []
      if (!child_items || child_items.length == 0) {
        return []
      }
      child_items.forEach((child) => {
        let data = {
          menu_id: child.menu_id,
          size_id: child.item_size_id,
          style_id: child.item_style_id,
          quantity: child.quantity,
          name: child.item_name,
          item_id: child.item_id,
          category_id: child.category_id,
          pick_list_id: child.pick_list_id,
          child_items: this.childItems(child.child_items),
        }
        if (!child.child_items) {
          delete data.child_items
        }
        childItems.push(data)
      })
      return childItems
    },
    generateOrderObject(item, action) {
      let itemObject = {
        menu_id: item.menu_id,
        size_id: item.item_size_id,
        style_id: item.item_style_id,
        quantity: item.quantity,
        item_id: item.item_id,
        category_id: item.category_id,
        comment: item.comment,
        child_items: this.childItems(item.child_items),
        order_item_id: item.order_item_id,
      }
      if (action == 'editClicked') {
        /* if (!item.child_items && !item.size) {
          this.$emit('openWithOutAddons', itemObject) 
        } */
        this.$emit('openWithAddons', itemObject)
      }
      if (action == 'changeQty') {
        return itemObject
      }
    },
    changeQty(type, item, index) {
      // find the item in this.orderData.order.items
      let orderItem = this.orderData.order.items.find((orderItem) => orderItem.item_id == item.item_id)
      // check max qty of the item
      if (orderItem.max_qty) {
        if (type == 'plus' && orderItem.quantity == orderItem.max_qty) {
          let toasterData = {
            show: true,
            message: 'Maximum quantity you can select is ' + orderItem.max_qty + ' for ' + orderItem.item_name,
          }
          this.SET_TOASTER(toasterData)
          return
        }
      }
      this.qtyLoading = true
      this.selectedItemId = item.item_id
      if (index) {
        this.selectedItemIndex = index
      }
      if (type == 'minus' && orderItem.quantity == 1) {
        this.removeItemClicked(orderItem)
        return
      }
      let orderId = this.orderData.order.order_id
      let customerId = localStorage.getItem('customerId')
      let currentQty = orderItem.quantity
      let newQty
      if (type == 'plus') {
        if (currentQty == 99) {
          this.qtyLoading = false
          let toasterData = {
            show: true,
            message: 'Maximum quantity you can select is 99 for ' + orderItem.item_name,
          }
          this.SET_TOASTER(toasterData)
          return
        }
        newQty = currentQty + 1
      } else {
        newQty = currentQty - 1
      }
      let payload = {
        customer_id: this.loggedIn ? customerId : localStorage.getItem('guestCustomerId'),
        items: [this.generateOrderObject(orderItem, 'changeQty')],
      }
      payload.items[0].quantity = newQty
      payload.items[0].order_item_id = orderItem.order_item_id
      payload.items[0].child_items.forEach((childItem) => {
        let childItemQuantityForOne = childItem.quantity / currentQty
        if (type == 'plus') {
          childItem.quantity = childItemQuantityForOne * (currentQty + 1)
        } else {
          childItem.quantity = childItemQuantityForOne * (currentQty - 1)
        }
        if (childItem.child_items) {
          childItem.child_items.forEach((childChildItem) => {
            let childChildItemQuantityForOne = childChildItem.quantity / currentQty
            if (type == 'plus') {
              childChildItem.quantity = childChildItemQuantityForOne * (currentQty + 1)
            } else {
              childChildItem.quantity = childChildItemQuantityForOne * (currentQty - 1)
            }
          })
        }
      })
      ordersApi
        .changeItemQuantity(orderId, payload)
        .then((response) => {
          this.qtyLoading = false
          this.selectedItemId = null
          this.selectedItemIndex = null
          this.SET_ORDER_DATA(response.data.data)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch(() => {
          this.qtyLoading = false
          this.selectedItemId = null
          this.selectedItemIndex = null
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later.',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    getTemperature() {
      externalApi
        .getWeather(this.selectedStore.latitude, this.selectedStore.longitude)
        .then((response) => {
          this.temperature = response.data.current_weather.temperature
        })
        .catch((error) => {
          console.log(error)
        })
    },
    openUpsellItem(item, category) {
      this.getItemData(item, category, 'add')
    },
    toggleFilterModal() {
      this.filterModalIsOpen = !this.filterModalIsOpen
      if (this.selectedStore?.extra?.enable_allergen_filter == true) {
        const preferencesAllergens = []
        const preferencesItemClasses = []

        const selectedMenu = this.menus[this.selectedMenuIndex]

        if (selectedMenu && selectedMenu.categories) {
          selectedMenu.categories.forEach((category) => {
            if (category.items) {
              category.items.forEach((item) => {
                item.allergen_ids.forEach((allergenId) => {
                  if (!preferencesAllergens.includes(allergenId)) {
                    preferencesAllergens.push(allergenId)
                  }
                })

                item.class_ids.forEach((classId) => {
                  if (!preferencesItemClasses.includes(classId)) {
                    preferencesItemClasses.push(classId)
                  }
                })
              })
            }
          })
        }

        this.preferencesAllergens = preferencesAllergens
          .map((allergenId) => {
            const allergen = this.storeConfig?.allergens.find((a) => a.id === allergenId)
            return allergen || null
          })
          .filter((allergen) => allergen !== null)

        this.preferencesItemClasses = preferencesItemClasses
          .map((itemClassId) => {
            const itemClass = this.storeConfig?.item_classes.find((a) => a.id === itemClassId)
            return itemClass || null
          })
          .filter((itemClass) => itemClass !== null)
      }
    },
    handleFilter(localSelectedAllergens, localSelectedItemClasses) {
      this.selectedAllergens = localSelectedAllergens
      this.selectedItemClasses = localSelectedItemClasses
      this.$store.commit('setSelectedAllergens', this.selectedAllergens)
      this.$store.commit('setSelectedItemClasses', this.selectedItemClasses)
    },

    clearFilter() {
      this.selectedAllergens = []
      this.selectedItemClasses = []
      this.selectedAllergens.length = 0
      this.selectedItemClasses.length = 0
      this.$store.commit('setSelectedAllergens', this.selectedAllergens)
      this.$store.commit('setSelectedItemClasses', this.selectedItemClasses)
      this.filterModalIsOpen = false
    },

    getPreferences() {
      this.preferencesAllergens = []
      this.preferencesItemClasses = []
      this.clearFilter()

      let customerID = localStorage.getItem('customerId')
      customersApi
        .getPreferences(customerID)
        .then((response) => {
          // this.preferencesAllergens = response?.data?.data?.allergens.sort((a, b) => a.name.localeCompare(b.name))
          // this.preferencesItemClasses = response?.data?.data?.item_classes.sort((a, b) => a.name.localeCompare(b.name))
          let prefs = response?.data?.data?.prefs
          if (prefs.exc_allergens) {
            this.selectedAllergens = prefs.exc_allergens
            this.$store.commit('setSelectedAllergens', this.selectedAllergens)
          }
          if (prefs.inc_item_classes) {
            this.selectedItemClasses = prefs.inc_item_classes
            this.$store.commit('setSelectedItemClasses', this.selectedItemClasses)
          }
        })
        .catch((error) => {
          if (error.response.data.status == 403) {
            let toasterData = {
              show: true,
              message: 'Your session has expired. Please log in again',
            }
            this.SET_TOASTER(toasterData)
            this.$emit('logout')
          }
          this.loading = false
          this.error.status = true
          this.error.message = 'Something went wrong. Please try again'
        })
    },
    checkQueryParams() {
      const newServiceType = this.$route.query.service_type
      const newTableNumber = this.$route.query.table_number

      const oldServiceType = localStorage.getItem('service_type')
      const oldTableNumber = localStorage.getItem('table_number')

      if (newServiceType === undefined) {
        localStorage.removeItem('service_type')
      }

      if (newTableNumber === undefined) {
        localStorage.removeItem('table_number')
      }

      if (newServiceType !== oldServiceType || newTableNumber !== oldTableNumber) {
        if (!this.dateAndTimeModalIsOpen) {
          this.toggleDateAndTimeModal()
        }

        if (newServiceType !== undefined) {
          localStorage.setItem('service_type', newServiceType)
        }
        if (newTableNumber !== undefined) {
          localStorage.setItem('table_number', newTableNumber)
        }
      }
    },
  },
  created() {
    let selectedStoreId = localStorage.getItem('selectedStoreId')
    let currentStoreId = this.$route.params.storeId
    if (selectedStoreId != currentStoreId) {
      this.SET_ORDER_DATA(null)
      localStorage.removeItem('dayAndTimeSelected')
      this.SET_DAY_AND_TIME_SELECTED(false)
      localStorage.removeItem('selectedDay')
      this.SET_SELECTED_DAY(null)
      localStorage.removeItem('selectedHour')
      this.SET_SELECTED_HOUR(null)
      localStorage.removeItem('selectedTip')
      localStorage.removeItem('tipSelected')
      localStorage.removeItem('selectedStoreId')
      this.SET_SELECTED_ADDRESS(null)
      localStorage.removeItem('selectedAddress')
    }
    if (this.loggedIn == true && this.selectedStore?.extra?.enable_allergen_filter == true) {
      this.getPreferences()
    }
    this.checkInnerWidth(window.innerWidth)
    window.addEventListener('resize', () => {
      const innerWidth = window.innerWidth
      this.checkInnerWidth(innerWidth)
    })
    if (this.selectedStore) {
      this.getTemperature()
    }
    this.storeId = this.$route.params.storeId
    this.getMenus()
    if (localStorage.getItem('dayAndTimeSelected')) {
      this.dateAndTimeModalIsOpen = false
    }
    window.addEventListener('resize', () => {
      const innerWidth = window.innerWidth
      this.innerWidth = innerWidth
    })
    this.checkQueryParams()
  },
  mounted() {
    // if filterDropdown is open, close it when user clicks outside of it
    document.addEventListener('click', (e) => {
      if (this.filterDropdownIsOpen) {
        if (!this.$refs.filterDropdown.contains(e.target)) {
          this.filterDropdownIsOpen = false
        }
      }
    })
    // add event listener for window resize
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })

    // if there is an active order and deepLinkItemId, add it to the cart
    let deepLinkItemId = localStorage.getItem('deepLinkItemId')
    if (this.orderData && deepLinkItemId) {
      this.addDeepLinkItemToCart()
    }
  },
  beforeUnmount() {
    // remove event listener when component is destroyed
    document.removeEventListener('click', (e) => {
      if (this.filterDropdownIsOpen) {
        if (!this.$refs.filterDropdown.contains(e.target)) {
          this.filterDropdownIsOpen = false
        }
      }
    })
    // remove event listener for window resize
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
}
</script>

<style src="../assets/css/views/MenuView.css" scoped></style>
